import helpers from '../helpers';

function openTeam() {
	setTimeout(() => {
		$('.team-content').addClass('is-active');
	}, 100);
}

function closeTeam() {
	setTimeout(() => {
		$('.team-content').removeClass('is-active');
	}, 100);
}

function init() {
	if (!helpers.isMobile()) {
		return;
	}

	helpers.$document.on('click.footer', (e) => {
		let $container = $('.team-content');

		if (!$container.is(e.target) && $container.has(e.target).length === 0 && $container.hasClass('is-active')) {
			closeTeam();
		}
	});

	$('.js-team-open').on('click.footer', openTeam);
}

function destroy() {
	if (!helpers.isMobile()) {
		return;
	}

	$('.js-team-open').off('.footer');
	helpers.$document.off('.footer');
}

export default {
	init,
	destroy,
};
